import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

export enum SAVE_CHANGES_RESULT {
  SAVE,
  DISCARD,
  CANCEL
}

export interface SaveChangesDialogData {
  title: string;
  message: string;
  params?: Record<string, unknown>;
}

@Component({
  selector: 'lfw-save-changes-dialog',
  templateUrl: './save-changes-dialog.component.html',
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class SaveChangesDialogComponent {
  readonly data = inject<SaveChangesDialogData>(MAT_DIALOG_DATA);

  SAVE_CHANGES_RESULT = SAVE_CHANGES_RESULT;
}
